/* eslint-disable */
export const USER_PROFILE_PERSIST_KEY = `profile:user`;

export const USER_PROFILE_SERVICE_PRESENCE_STATUS_AWAY = `away`;
export const USER_PROFILE_SERVICE_PRESENCE_STATUS_OFFLINE = `offline`;
export const USER_PROFILE_SERVICE_PRESENCE_STATUS_PRESENT = `present`;
export const USER_PROFILE_SERVICE_PRESENCE_STATUS_UNKNOWN = `unknown`;

export const USER_PROFILE_SERVICE_PRESENCE_TIMEOUT_THRESHOLD = 1 * 60 * 1000; // 1 minute

export const USER_PROFILE_NOTIFIED_ABOUT_SMS = `notifiedAboutSms`;
export const USER_PROFILE_CONFIRMED_MOBILE = `confirmedMobile`;
